export const formatSchoolId = (schoolName: string, userId: string): string => {
  if (!schoolName) return 'UNKNOWN';
  
  // Get first 3 letters of school name, removing spaces
  const schoolPrefix = schoolName.replace(/\s+/g, '').slice(0, 3).toUpperCase();
  
  // Use userId to generate consistent random part
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let randomPart = '';
  
  // Use userId as seed for consistent generation
  const seed = userId.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  for (let i = 0; i < 3; i++) {
    const randomIndex = (seed + i * 31) % characters.length;
    randomPart += characters[randomIndex];
  }
  
  // Combine with a hyphen
  return `${schoolPrefix}-${randomPart}`;
}; 